import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Download = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Download' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,12 L12,19 L19,12' />
  </StyledIcon>
);
